import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

// Every endpoint takes the same {from, to} window params.
const report = (name) => (params) => api.get(`/v1/analytics/${name}`, { params }).then(unwrap);

export default {
  overview:            report('overview'),
  funnel:              report('funnel'),
  sources:             report('sources'),
  responseTimes:       report('response-times'),
  leaderboard:         report('leaderboard'),
  appointments:        report('appointments'),
  aiContribution:      report('ai-contribution'),
  campaignAttribution: report('campaign-attribution'),
};
